import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import EventDetails from './components/EventDetails';
import ProfilePictureGenerator from './components/ProfilePictureGenerator';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<EventDetails />} />
          <Route path="/generator" element={<ProfilePictureGenerator />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;